import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  className?: string;
  showLabel?: boolean;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ 
  className = '', 
  showLabel = false 
}) => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = i18n.language;

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {showLabel && (
        <span className="text-sm text-gray-600 font-medium">
          {t('language.switch')}:
        </span>
      )}
      <div className="flex bg-gray-100 rounded-lg p-1">
        <button
          onClick={() => changeLanguage('en')}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors ${
            currentLanguage === 'en'
              ? 'bg-white text-blue-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
          title={t('language.english')}
        >
          EN
        </button>
        <button
          onClick={() => changeLanguage('es')}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors ${
            currentLanguage === 'es'
              ? 'bg-white text-blue-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
          title={t('language.spanish')}
        >
          ES
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher; 